export type LastWorkspace = {
	workspaceId: string;
	writtenAt: number;
};

const LAST_WORKSPACE_WRITE_STATUSES = [
	'SUCCESS',
	'BLOCKED',
	'FAILED',
	'ERROR',
	'NO_RESULT',
] as const;

export type LastWorkspaceWriteStatus = (typeof LAST_WORKSPACE_WRITE_STATUSES)[number];

export const isLastWorkspaceWriteStatus = (value: unknown): value is LastWorkspaceWriteStatus =>
	LAST_WORKSPACE_WRITE_STATUSES.includes(value as LastWorkspaceWriteStatus);
